import {
  Card,
  Grid,
  Box,
  Typography,
  IconButton,
  Chip,
  useMediaQuery,
  useTheme,
  Avatar,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import BookmarkBorderIcon from '@mui/icons-material/BookmarkBorder';
import BookmarkIcon from '@mui/icons-material/Bookmark';
import WorkOutlineIcon from '@mui/icons-material/WorkOutline';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import { useNavigate } from 'react-router-dom';
import routes from '../../Utils/routes';
import { getJobsBookmark, postJobsBookmark } from '../../Utils/apiService';
import { enqueueSnackbar } from 'notistack';
import { text } from 'stream/consumers';
import getSymbolFromCurrency from 'currency-symbol-map';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

export default function JobCards(props: any) {
  const {
    value,
    userData,
    carrierJobs,
  } = props;

  console.log(value, "skdnsli");

  const [bookmarksData, setBookmarksData] = useState<any[]>([]);
  const [isBookmarked, setIsBookmarked] = useState<boolean>(false);
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`${routes.jobDetails}/${value?.Id}`, {
      state: { breadCrumbs: value?.Job_Title__c },
    });
  };

  const fetchBookmarks = async () => {
    try {
      const res = await getJobsBookmark(userData.applicantId);
      const saved = res.data.savedJobs || [];
      setBookmarksData(saved);
      const bookmarked = saved.some((job: any) => job?.Id === value?.Id);
      setIsBookmarked(bookmarked);
    } catch (err) {
      console.error(err);
    }
  };

  const handleBookmark = async () => {
    const payLoad = {
      contactId: userData.applicantId,
      jobId: value.Id,
      isBookmarked: !isBookmarked,
    };

    try {
      const res = await postJobsBookmark(payLoad, userData.applicantId);
      if (res?.success) {
        setIsBookmarked(!isBookmarked);
        enqueueSnackbar({
          message: 'Bookmark updated successfully',
          variant: 'success',
          autoHideDuration: 1000,
        });
        fetchBookmarks(); // Sync bookmarks list again
      } else {
        enqueueSnackbar({
          message: 'Something went wrong',
          variant: 'error',
          autoHideDuration: 1000,
        });
      }
    } catch (err) {
      enqueueSnackbar({
        message: 'Something went wrong',
        variant: 'error',
        autoHideDuration: 1000,
      });
      console.error(err);
    }
  };

  useEffect(() => {
    fetchBookmarks();
  }, []);

  const date = new Date(value?.CreatedDate);
  const formattedDate =
    date.getDate().toString().padStart(2, '0') +
    '/' +
    (date.getMonth() + 1).toString().padStart(2, '0') +
    '/' +
    date.getFullYear();

  const workplaceType = value?.Work_Place_Type__c?.split(';');
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isMobile1 = useMediaQuery(theme.breakpoints.down('xs'));

  return (
    <div>
      {!isMobile ? (
        <Card
          sx={{
            backgroundColor: '#F6F8FB',
            padding: '10px',
            cursor: 'pointer',
            borderRadius: '9px',
            boxShadow: 'none',
            height: '220px',
            // display: 'flex',
            // flexDirection: 'column',
            // justifyContent: 'space-between',
            '@media (min-width: 1280px) and (max-width: 1300px)': {
              height: '35vh',
            },
          }}
        >
          <Grid container columnSpacing={"12px"}>
            <Grid item xs={2.5}>
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  background: '#FFFFFF',
                  borderRadius: '6px',
                  padding: '10px',
                }}
              >
                <img
                  src={value?.Organization__r?.Logo_File_URL__c}
                  height="28px"
                  width="28px"
                  alt=''
                />
              </Box>
            </Grid>
            <Grid item xs={7.5} onClick={handleClick} textAlign={"start"}  >
              <Typography fontWeight={500} fontSize={'15px'}>
                {value?.Job_Title__c}
              </Typography>
              <Typography fontWeight={400} fontSize={'10.5px'}>
                {value?.Location__c}
              </Typography>
            </Grid>
            <Grid item xs={2}>
              <Box display="flex" justifyContent="end">
                <IconButton onClick={handleBookmark}>
                  {isBookmarked ? (
                    <BookmarkIcon sx={{ color: '#585A64', fontSize: '20px' }} />
                  ) : (
                    <BookmarkBorderIcon sx={{ fontSize: '20px' }} />
                  )}
                </IconButton>
              </Box>
            </Grid>
          </Grid>
          <Box onClick={handleClick} >
            <Box display="flex" mt={1}>
              {workplaceType?.map((val: string | number | boolean | React.ReactElement<any, string | React.JSXElementConstructor<any>> | Iterable<React.ReactNode> | React.ReactPortal | null | undefined, idx: React.Key | null | undefined) => (
                <Chip
                  key={idx}
                  label={val}
                  size="small"
                  sx={{
                    backgroundColor: '#FDE4B1',
                    color: 'black',
                    fontWeight: 400,
                    fontSize: '9px',
                    ml: idx === 0 ? 0 : 1,
                  }}
                />
              ))}
            </Box>
            <Box display="flex" mt={3}>
              <WorkOutlineIcon fontSize="small" sx={{ fontSize: '12px', color: "#373A45" }} />
              <Typography fontWeight={400} fontSize={'9px'} ml={0.5} color={"#373A4d"}>
                Experience: {value?.Experience_Start_Level__c ?? '0'}-
                {value?.Experience_End_Level__c ?? '0'} years
              </Typography>
            </Box>
            <Box display="flex" mt={"12px"} alignItems={"center"}>
              {/* <CurrencyRupeeIcon fontSize="small" sx={{ fontSize: '12px' }} /> */}
              <Typography color={"#373A4d"} fontSize={12}>{value?.Currency_Type__c ? getSymbolFromCurrency(value?.Currency_Type__c) || '₹' : "₹"}</Typography>
              <Typography color={"#373A4d"} fontWeight={600} fontSize={'10.5px'} ml={0.5}>
                {value?.Salary_Start_Range__c}-{value?.Salary_End_Range__c}
              </Typography>
            </Box>
            <Box marginTop={"12px"} display={"flex"} alignItems={"center"} justifyContent={"space-between"} >
              <>
                {carrierJobs === 'PostedByMe' ?
                  <Grid item xs={6} sx={{textAlign:"start"}}>
                    <Chip
                      label={
                        value?.Approval_Status__c
                          ? value?.Approval_Status__c
                          : 'Pending Approval'
                      }
                      size="small"
                      sx={{
                        backgroundColor:
                          value?.Approval_Status__c === 'Approved'
                            ? 'green'
                            : value?.Approval_Status__c === 'Rejected'
                              ? 'red'
                              : '#FEEBBE',
                        color:
                          value?.Approval_Status__c === 'Approved' ||
                            value?.Approval_Status__c === 'Rejected'
                            ? 'white'
                            : '#000',
                      }}
                    />
                  </Grid>
                  :
                  <Box display={"flex"} gap={"4px"} alignItems={"center"}>
                    <Typography fontSize={"9px"} textAlign={"start"}>Posted By : </Typography>
                    <Avatar alt="Remy Sharp" sx={{ height: '22px', width: '22px' }} src={value?.Organization__r?.Logo_File_URL__c} />
                    <Typography fontWeight={500} fontSize={"9px"}>{value?.Organization__r?.Name}</Typography>
                  </Box>
                }
              </>
              <Box>
                <ArrowForwardIcon />
              </Box>
            </Box>

            {/* <Grid container spacing={2} sx={{ mt: 0.1 }}>
               {carrierJobs === 'PostedByMe' && (
                <Grid item xs={6}>
                  <Chip
                    label={
                      value?.Approval_Status__c
                        ? value?.Approval_Status__c
                        : 'Pending Approval'
                    }
                    size="small"
                    sx={{
                      backgroundColor:
                        value?.Approval_Status__c === 'Approved'
                          ? 'green'
                          : value?.Approval_Status__c === 'Rejected'
                            ? 'red'
                            : '#FEEBBE',
                      color:
                        value?.Approval_Status__c === 'Approved' ||
                          value?.Approval_Status__c === 'Rejected'
                          ? 'white'
                          : '#000',
                    }}
                  />
                </Grid>
              )}
            </Grid> */}
          </Box>
        </Card>
      ) : (
        <Card
          sx={{
            backgroundColor: '#F6F8FB',
            padding: '10px',
            height: '230px',
            cursor: 'pointer',
            overflow: 'hidden',
            borderRadius: '9px',
            boxShadow: 'none',
          }}
        >
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Box
                  sx={{
                    height: '30px',
                    width: '30px',
                    background: '#FFFFFF',
                    borderRadius: '6px',
                    padding: '4px',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                  }}
                >
                  <img
                    src={value?.Organization__r?.Logo_File_URL__c}
                    height="20px"
                    width="20px"
                    alt=''
                  />
                </Box>
                <IconButton onClick={handleBookmark} size="small" sx={{ mt: 1 }}>
                  {isBookmarked ? (
                    <BookmarkIcon sx={{ color: '#585A64', fontSize: '18px' }} />
                  ) : (
                    <BookmarkBorderIcon sx={{ fontSize: '18px' }} />
                  )}
                </IconButton>
              </div>
            </Grid>
            <Grid item xs={12} sx={{ textAlign: 'left' }}>
              <Box onClick={handleClick}>
                <Typography fontWeight={500} fontSize={'15px'}>
                  {value?.Job_Title__c}
                </Typography>
                <Typography fontWeight={400} fontSize={'11px'}>
                  {value?.Organization__r?.Name}
                </Typography>
                <Typography fontWeight={500} fontSize={'10px'} mt={2}>
                  Location: {value?.Location__c}
                </Typography>
                <Box display="flex" mt={0.5} fontSize={'8px'} alignItems="center">
                  PayRange:
                  <Typography fontSize={12}>
                    {getSymbolFromCurrency(value?.Currency_Type__c) || '₹'}
                  </Typography>
                  <Typography fontWeight={600} fontSize={'10.5px'} ml={0.5}>
                    {value?.Salary_Start_Range__c}-{value?.Salary_End_Range__c}
                  </Typography>
                </Box>
                <Box marginTop={"12px"} display={"flex"} gap={"4px"} alignItems={"center"}>
                  <Typography fontSize={"9px"} textAlign={"start"}>Posted By : </Typography>
                  <Typography fontWeight={500} fontSize={"9px"}>{value?.Organization__r?.Name}</Typography>

                  {/* <Avatar alt="Remy Sharp" sx={{ height: '22px', width: '22px' }} src={value?.Organization__r?.Logo_File_URL__c} /> */}

                </Box>
                <Box display="flex" flexWrap="wrap" mt={1}>
                  {workplaceType?.map((val: any, idx: any) => (
                    <Chip
                      key={idx}
                      label={val}
                      size="small"
                      sx={{
                        backgroundColor: '#FDE4B1',
                        color: 'black',
                        fontWeight: 400,
                        fontSize: '9px',
                        ml: idx === 0 ? 0 : 1,
                        mt: 0.5,
                      }}
                    />
                  ))}
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Card>
      )}
    </div>
  );
}
